<template>
  <div v-loading="loading" class="main-div">
    <agentRegister :value="registerInfo" :visible.sync="dialogFormVisible" v-if="dialogFormVisible" @success="registerSuccess" :error-msg="errorMsg" :isInstitution="true" :readOnly="readOnly"></agentRegister>
  </div>
</template>

<script>
import agentRegister from '@/views/login/agentRegister'
import { customerInfo } from '@/api/partner'
export default {
  components: {
    agentRegister
  },
  data () {
    return {
      registerInfo: {},
      dialogFormVisible: false,
      loading: false,
      errorMsg: '',
      readOnly: false,
      agentId: ''
    }
  },
  created () {
    if (JSON.stringify(this.$route.query) !== '{}') {
      const query = this.$route.query
      if (this.agentId !== query.id) {
        this.agentId = query.id
        localStorage.setItem('institutionDetailId', query.id)
      }
    } else {
      if (localStorage.getItem('institutionDetailId') !== '') {
        this.agentId = localStorage.getItem('institutionDetailId')
      }
    }
  },
  mounted () {
    this.getRegitserInfo()
  },
  methods: {
    getRegitserInfo () {
      this.loading = true
      this.dialogFormVisible = false
      customerInfo({ id: this.agentId }).then(res => {
        this.loading = false
        if (parseInt(res.error_code) === 0) {
          this.dialogFormVisible = true
          this.readOnly = res.data.status !== 0
          this.registerInfo = res.data
          this.registerInfo.subAgentClass = 0
          this.registerInfo.agentId = this.agentId
          this.errorMsg = res.data.checkMsg
        } else {
          this.$message({
            type: 'error',
            showClose: true,
            message: res.error_msg
          })
        }
      })
    },
    registerSuccess () {
      this.$router.push('/Partner/Institution/institutionList')
    }
  }
}
</script>

<style lang="scss" scoped>
.main-div {
  min-height: 100vh;
  // width: 100vw;
}
</style>
